import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppConfig } from '../../app.config';
import { PopupService } from './popup.service';
import { ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import * as jwt_decode from "jwt-decode";

@Injectable()
export class AuthenticationService {

    private authWindow: any = null;;
    private code: any;
    private intervalId: any = null;
    private expiresTimerId: any = null;
    private loopCount = 600;
    private intervalLength = 100;


    constructor(private http: Http, private config: AppConfig, private popup: PopupService, private route: ActivatedRoute, public jwtHelper: JwtHelperService) {

    }

    public isAuthenticated(): boolean {
        const token = localStorage.getItem('currentUser');
        //console.log("authenticated:" + !this.jwtHelper.isTokenExpired());
        // Check whether the token is expired and return
        // true or false
        //console.log(this.jwtHelper.decodeToken());
        //console.log(this.jwtHelper.getTokenExpirationDate());
        return !this.jwtHelper.isTokenExpired();
    }

    public needPasswordReset(): boolean {
       
        var token = JSON.parse(localStorage.getItem('currentUser'));
        const needPasswordReset = localStorage.getItem(token.id + "_resetpassword");
        if (needPasswordReset == "true") {
            
            return true;
        }
        else
            return false;
    }

    public getDecodedAccessToken(token: string): any {
        try {
            return jwt_decode(token);
        }
        catch (Error) {
            return null;
        }
    }

    public isInRole(role: string): boolean {
        try {
            var tokens = this.getDecodedAccessToken(localStorage.getItem('currentUser'));
            //console.log(tokens);
            var roles = tokens["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
            //console.log(roles);
            if (roles.indexOf(role) !== -1) {
                return true;
            }
            return false;
        } catch (Error) {
            return false;
        }
    }

    public canEditUsers(): boolean {
        try {
            var tokens = this.getDecodedAccessToken(localStorage.getItem('currentUser'));
            var canEdit = this.isInRole("System Administrator") || this.isInRole("Customer Support") || (tokens['canedituser']==="True");
            //console.log(roles);
            if (canEdit) {
                return true;
            }
            return false;
        } catch (Error) {
            return false;
        }
    }

    public canEditFacilitySettings(): boolean {
        try {
            var canEdit = this.isInRole("System Administrator") || this.isInRole("Customer Support");
            return canEdit;
        } catch (Error) {
            return false;
        }
    }
   
    login(username: string, password: string) {
        let headers = new Headers({ 'Access-Control-Allow-Origin': '*' });

        return this.http.post(this.config.apiUrl + '/api/auth/login', { username: username, password: password }, { headers })
            .pipe(map((response: Response) => {
                //console.log(response.json());

                let user = response.json();
                if (user && user.auth_token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    localStorage.setItem(user.id + "_resetpassword", "false");
                }
                return user;
            }),
            catchError(this.handleError))

        //return this.http.post(this.config.apiUrl + '/api/auth/login', { username: username, password: password }, { headers })
        //    .map((response: Response) => {
        //        // login successful if there's a jwt token in the response
        //        console.log(response.json());
        //        let user = response.json();
                
        //        if (user && user.auth_token) {
        //            // store user details and jwt token in local storage to keep user logged in between page refreshes
        //            localStorage.setItem('currentUser', JSON.stringify(user));
        //        }

        //    }).catch(this.handleError);;
    }



    pccLogin(accessToken: string) {
        //console.log("inside pcclogin")
        return this.http.post(this.config.apiUrl + '/api/externalauth/pcc', { code: accessToken })
            .pipe(map((response: Response) => {
                // login successful if there's a jwt token in the response
                let user = response.json();
                //console.log(user.auth_token);
                if (user && user.auth_token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    localStorage.removeItem(user.id + "_resetpassword");
                }
            }),
            catchError (this.handleError))
    }

    logout() {
        //console.log(this.config.apiUrl);
        
        // remove user from local storage to log user out
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        localStorage.removeItem('currentUser');
        console.log("CurrentUser on logout "  + currentUser);
        if (currentUser != null) {
            let authToken = currentUser.auth_token;
            let headers = new Headers();

            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', 'Bearer ' + authToken);
            return this.http.post(this.config.apiUrl + '/api/account/logout',null, { headers })
                .pipe(map((response: Response) => {
                    // logout successful
                    console.log(response);
                }),
                catchError (this.handleError))
            
        }
        
    }

    //Validate Country
    webRequestFrom() :any{
        //console.log("CurrentUser location ");
        
        // var keyForipstack = c1023a3bf438eb8e9d4293e563b413fb;
        // ip stack http://api.ipstack.com/<ip>?access_key=c1023a3bf438eb8e9d4293e563b413fb


        //using geo IP Too; https://app.ipgeolocation.io/
        //var key = '971b7bb51e884eb9a59bc78efa84ea7c'; // geoip
        /*
        return this.http.get('https://api.ipgeolocation.io/ipgeo?apiKey=' + key, {})
            .map((response: Response) => {
                console.log(response);
                return response.json();
            }).catch(this.handleError);
        */


        //Free one api key eccde1e0-3404-11e9-b19e-bb3ec4e6a48e
        //https://geoip-db.com/json/eccde1e0-3404-11e9-b19e-bb3ec4e6a48e
        var key = 'eccde1e0-3404-11e9-b19e-bb3ec4e6a48e';
        return this.http.get('https://geolocation-db.com/json/' + key, {})
            .pipe(map((response: Response) => {
                //console.log(response);
                return response.json();
            }),
            catchError (this.handleError))
    }



    // private helper methods
    private handleError(error: Response) {
        
        var applicationError = error.headers.get('Application-Error');

        // either applicationError in header or model error in body
        if (applicationError) {
            return Observable.throw(applicationError);
        }

        var modelStateErrors: string = '';
        var serverError = error.json();
        
        if (!serverError.type) {
            for (var key in serverError) {
                if (serverError[key])
                    modelStateErrors += serverError[key] + '\n';
            }
        }

        //console.log(serverError);
        if (serverError.token) {
            let user = serverError.token;
            //console.log(user.auth_token);
            if (user && user.auth_token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                localStorage.setItem(user.id+"_resetpassword", "true");
            }
            return Observable.throw("Reset Password");
        }

        modelStateErrors = modelStateErrors = '' ? null : modelStateErrors;
        return Observable.throw(modelStateErrors || 'Server error');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/authentication.service.ts